import styled from "styled-components";

export const ToggleSwitch = styled.button<{ $checked: boolean }>`
    position: relative;
    width: 40px;
    height: 22px;
    border-radius: 999px;
    border: 1px solid ${(props) => (props.$checked ? props.theme.palette.accent.dark : props.theme.palette.grey)};
    background: ${(props) => (props.$checked ? props.theme.palette.accent.dark : props.theme.palette.grey)};
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    transition: background-color 0.15s ease, border-color 0.15s ease;

    &:disabled {
        cursor: default;
        opacity: 0.6;
    }

    &:hover:not(:disabled) {
        border-color: ${(props) => props.theme.palette.accent.dark};
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${(props) => props.theme.shadowTypes.buttonFocus};
    }

    &::after {
        content: "";
        position: absolute;
        top: 2px;
        left: ${(props) => (props.$checked ? "20px" : "2px")};
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: ${(props) => props.theme.palette.white};
        transition: left 0.15s ease;
    }
`;